(() => {
  const q = (selector, context = document) => context.querySelector(selector);
  const qa = (selector, context = document) => [...context.querySelectorAll(selector)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const desktop = matchMedia('(min-width: 960px)');

  qa('[data-product-gallery-v62]').forEach((gallery) => {
    if (gallery.dataset.v62Ready === 'true') return;
    gallery.dataset.v62Ready = 'true';
    const product = gallery.closest('.wr-product');
    const images = qa('.wr-product-media-image', gallery);
    const bars = qa('.wr-gallery-progress i', gallery);
    const lightbox = q('[data-product-lightbox]', product);
    const lightboxScroller = q('[data-product-lightbox-images]', lightbox);
    const lightboxImages = qa('[data-product-lightbox-image]', lightbox);
    const thumbs = qa('[data-product-lightbox-thumb]', lightbox);
    let active = 0;
    let pointerStart = null;
    let touchStart = null;
    let previousFocus = null;

    /* Escape section stacking contexts so the gallery truly covers the viewport. */
    if (lightbox && lightbox.parentElement !== document.body) document.body.appendChild(lightbox);

    const setActive = (next) => {
      if (!images.length) return;
      active = (next + images.length) % images.length;
      images.forEach((image, index) => image.classList.toggle('is-active', index === active));
      bars.forEach((bar, index) => bar.classList.toggle('is-active', index === active));
      thumbs.forEach((thumb, index) => thumb.classList.toggle('is-active', index === active));
      gallery.dataset.galleryIndex = String(active);
    };

    const scrollLightboxTo = (index, behavior = 'smooth') => {
      const target = lightboxImages[index];
      if (!target) return;
      active = index;
      thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === active));
      lightboxScroller?.scrollTo({ top: target.offsetTop, behavior: reduced ? 'auto' : behavior });
    };

    const openLightbox = (index = active) => {
      if (!lightbox) return;
      previousFocus = document.activeElement;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('wr-product-lightbox-open');
      requestAnimationFrame(() => scrollLightboxTo(index, 'auto'));
      window.setTimeout(() => q('[data-product-lightbox-close]', lightbox)?.focus({ preventScroll: true }), reduced ? 0 : 220);
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('wr-product-lightbox-open');
      previousFocus?.focus?.({ preventScroll: true });
    };

    q('[data-product-gallery-open]', gallery)?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openLightbox(active);
    });

    q('[data-product-lightbox-close]', lightbox)?.addEventListener('click', closeLightbox);
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => scrollLightboxTo(Number(thumb.dataset.imageIndex || 0))));

    if (lightboxScroller && lightboxImages.length) {
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        const index = Number(visible.target.dataset.imageIndex || 0);
        active = index;
        thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === index));
      }, { root: lightboxScroller, threshold: [.55, .8] });
      lightboxImages.forEach((image) => observer.observe(image));
    }

    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });

    gallery.addEventListener('pointerdown', (event) => {
      if (desktop.matches || event.pointerType === 'touch' || event.target.closest('button,a')) return;
      pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
    }, { passive: true });

    gallery.addEventListener('pointerup', (event) => {
      if (desktop.matches || event.pointerType === 'touch' || !pointerStart || event.target.closest('button,a')) return;
      const dx = event.clientX - pointerStart.x;
      const dy = event.clientY - pointerStart.y;
      const rect = gallery.getBoundingClientRect();
      const wasSwipe = Math.abs(dx) > 34 && Math.abs(dx) > Math.abs(dy);
      if (wasSwipe) setActive(active + (dx < 0 ? 1 : -1));
      else if (Math.abs(dx) < 10 && Math.abs(dy) < 10) setActive(active + (event.clientX - rect.left >= rect.width / 2 ? 1 : -1));
      pointerStart = null;
    }, { passive: true });

    gallery.addEventListener('touchstart', (event) => {
      if (desktop.matches || event.target.closest('button,a') || !event.changedTouches[0]) return;
      const touch = event.changedTouches[0];
      touchStart = { x: touch.clientX, y: touch.clientY };
    }, { passive: true });

    gallery.addEventListener('touchend', (event) => {
      if (desktop.matches || !touchStart || event.target.closest('button,a') || !event.changedTouches[0]) return;
      const touch = event.changedTouches[0];
      const dx = touch.clientX - touchStart.x;
      const dy = touch.clientY - touchStart.y;
      if (Math.abs(dx) > 32 && Math.abs(dx) > Math.abs(dy)) {
        setActive(active + (dx < 0 ? 1 : -1));
        pointerStart = null;
      }
      touchStart = null;
    }, { passive: true });

    gallery.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Enter') return;
      event.preventDefault();
      if (event.key === 'Enter' && desktop.matches) openLightbox(active);
      else setActive(active + (event.key === 'ArrowRight' ? 1 : -1));
    });

    images.forEach((image, index) => image.addEventListener('click', (event) => {
      if (!desktop.matches) return;
      event.preventDefault();
      openLightbox(index);
    }));

    if (desktop.matches && images.length > 1) {
      const galleryObserver = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) setActive(images.indexOf(visible.target));
      }, { rootMargin: '-36% 0px -36% 0px', threshold: [0, .1] });
      images.forEach((image) => galleryObserver.observe(image));
    }

    document.addEventListener('keydown', (event) => {
      if (!lightbox?.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowUp') scrollLightboxTo(Math.max(0, active - 1));
      if (event.key === 'ArrowDown') scrollLightboxTo(Math.min(lightboxImages.length - 1, active + 1));
    });

    setActive(0);
  });

  const productStage = q('.template-product .wr-product-stage');
  if (productStage && desktop.matches) {
    const gallery = q('[data-product-gallery-v62]', productStage);
    const recommendations = q('.wr-recommendations', productStage.closest('.wr-product'));
    const sides = qa('.wr-product__left, .wr-product__buy', productStage);
    let frame = 0;
    let pinned = false;

    const unpin = () => {
      sides.forEach((side) => {
        side.classList.remove('is-v62-fixed', 'is-v62-obscured');
        side.style.removeProperty('--wr-v62-fixed-left');
        side.style.removeProperty('--wr-v62-fixed-width');
      });
      pinned = false;
    };

    const pin = () => {
      const rects = sides.map((side) => side.getBoundingClientRect());
      sides.forEach((side, index) => {
        side.style.setProperty('--wr-v62-fixed-left', rects[index].left + 'px');
        side.style.setProperty('--wr-v62-fixed-width', rects[index].width + 'px');
        side.classList.add('is-v62-fixed');
      });
      pinned = true;
    };

    const updatePinnedSides = () => {
      if (!gallery) return;
      const rect = gallery.getBoundingClientRect();
      const recommendationTop = recommendations?.getBoundingClientRect().top ?? Number.POSITIVE_INFINITY;
      const shouldPin = rect.top <= 104;
      const shouldObscure = recommendationTop <= innerHeight;
      if (shouldPin && !pinned) pin();
      if (!shouldPin && pinned) unpin();
      if (pinned) sides.forEach((side) => side.classList.toggle('is-v62-obscured', shouldObscure));
      frame = 0;
    };

    const requestUpdate = () => {
      if (!frame) frame = requestAnimationFrame(updatePinnedSides);
    };

    updatePinnedSides();
    addEventListener('scroll', requestUpdate, { passive: true });
    addEventListener('resize', () => {
      unpin();
      requestUpdate();
    }, { passive: true });
  }

  qa('[data-collection-tools]').forEach((tools) => {
    const toggle = q('[data-filter-drawer-toggle]', tools);
    const drawer = q('[data-filter-drawer]', tools);
    const close = q('[data-filter-drawer-close]', tools);
    if (!toggle || !drawer) return;
    const setOpen = (open) => {
      drawer.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) q('input,button,select', drawer)?.focus({ preventScroll: true });
    };
    toggle.addEventListener('click', () => setOpen(drawer.hidden));
    close?.addEventListener('click', () => setOpen(false));
  });
})();
